import './RegStepPopmenuLocation.scss';
import {Button} from "../account/misc/Button";
import { Select } from 'antd';
import {useCallback, useEffect, useState } from 'react';
import {PopmenuLocationDto} from "../../generated/dashboard-client";
import PosApi from "../../api/PosApi";
import DashboardApi from "../../api/DashboardApi";
import AccountLocationApi from "../../api/AccountLocationApi";
import {error} from "../../service/MessageService";
import AccountsApi from "../../api/AccountsApi";
import {LocationDto} from "../../generated/dashboard-client";
import {findStateByAbbreviation} from "../../util/countries";

interface RegStepPopmenuLocationProps {
  onNext: () => void;
}

const {Option} = Select;

export default function RegStepPopmenuLocation({onNext}: RegStepPopmenuLocationProps) {
  const [pLocations, setPLocations] = useState<PopmenuLocationDto[]>([]);
  const [primaryPopmenuLocationId, setPrimaryPopmenuLocationId] = useState(undefined as string | undefined);
  const [primaryLocation, setPrimaryLocation] = useState<LocationDto>({} as LocationDto);
  const [memberId, setMemberId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [locationLoading, setLocationLoading] = useState(true);

  useEffect(() => {
    DashboardApi.status().then((resp) => {
      const {member} = resp.data;
      setMemberId((member?.ownerId || member?.internalId) ?? 0);
    });
  }, []);

  useEffect(() => {
    if (!memberId) return;
    setLoading(true);
    PosApi.getPopmenuLocations(memberId).then(resp => {
      setPLocations(resp.data);
      setLoading(false);
    });
  }, [memberId]);

  useEffect(() => {
    if (!pLocations?.length) return;
    setPrimaryPopmenuLocationId(pLocations[0].dbId ?? '');
    setLocationLoading(false);
  }, [pLocations]);

  const fetchPrimaryLocation = useCallback(() => {
    if (!memberId) return;
    setLoading(true);
    AccountsApi.getPrimaryUserLocation(memberId)
      .then(resp => setPrimaryLocation(resp.data))
      .catch(() => setLoading(false));
  }, [memberId]);

  useEffect(fetchPrimaryLocation, [fetchPrimaryLocation]);

  function onSave() {
    setLoading(true);

    const handleError = (ex: any) => {
      error(ex.response.data.message);
      setLoading(false);
    }

    AccountLocationApi.updateLocation(getLocation()).then(() => {
      setLoading(false);
      onNext();
    }).catch(handleError);
  }

  const getLocation = useCallback(() => {
    const primaryPopmenuLocation = pLocations.find((p) => p.dbId === primaryPopmenuLocationId)!!;
    return {
      ...primaryLocation,
      name: primaryPopmenuLocation.name,
      city: primaryPopmenuLocation.city,
      state: findStateByAbbreviation(primaryPopmenuLocation.state ?? '') || primaryPopmenuLocation.state,
      country: primaryPopmenuLocation.country === 'US' ? "United States of America" : primaryPopmenuLocation.country,
      zip: primaryPopmenuLocation.postalCode + '',
      address: primaryPopmenuLocation.streetAddress,
      popmenuLocationId: primaryPopmenuLocation.dbId
    }
  }, [primaryLocation, primaryPopmenuLocationId, pLocations]);

  return <div className={'pop-loc-container step full'}>
    <header>
      <h3>Choose primary Popmenu location</h3>
    </header>

    <section>
      <Select placeholder="Select Popmenu Location" onChange={val => setPrimaryPopmenuLocationId(val)} value={primaryPopmenuLocationId} loading={locationLoading}>
        {pLocations.map(it => <Option key={it.dbId}>{it.name}</Option>)}
      </Select>
    </section>

    <footer>
      <Button size={"Large"} className={"primary"} onClick={onSave} disabled={locationLoading || loading} loading={locationLoading || loading}>Next</Button>
    </footer>
  </div>
}
